<template>
  <div class="home">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    handleAvatarChange(file) {
      console.log(file);
      this.getTimes(file);
    },
    getTimes(file) {
      var content = file.raw;
      //获取录音时长
      var url = URL.createObjectURL(content);
      //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", () => {
        const audioDuration = audioElement.duration;
        console.log(audioDuration);
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
